<template>
  <div>
    <!-- 添加 -->
    <template>
      <Modal v-model="visible" title="添加集团" draggable class-name="vertical-center-modal" ok-text="添加" width="730" height="300"
        style="overflow: hidden;" @on-ok="ok" @on-cancel="cancel" :loading="loading">
        <Form ref="details" :model="details" :rules="ruleValidate" label-position="right" :label-width="100" style="width: 714px; height: 400px; margin: 0 auto; overflow-y: auto; padding-top: 20px;">

          <Row span="24">
            <Col span="10">
              <FormItem label="集团编号" prop="GroupCode">
                <Input v-model="details.GroupCode" placeholder="请输入集团编号"></Input>
              </FormItem>
            </Col>
            <Col span="10">
              <FormItem label="集团名称" prop="GroupName">
                <Input v-model="details.GroupName" placeholder="请输入集团名称"></Input>
              </FormItem>
            </Col>
          </Row>

        </Form>
      </Modal>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      },
      details: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        visible: false,
        formLeft: {},
        loading: true,

        ruleValidate: {
          GroupCode: [{ required: true, message: '集团编号不能为空', trigger: 'blur' }],
          GroupName: [{ required: true, message: '集团名称不能为空', trigger: 'blur' }]
        }
      }
    },
    watch: {
      isShow(newValue, old) {
        this.visible = newValue;
        if (this.visible) {
          console.log(123456)
        }
      }
    },
    mounted() {

    },
    methods: {

      ok(value) {
        let _this = this;
        _this.$refs.details.validate(valid => {
            if (valid) {
                _this.$emit("on-change", false, _this.details);
            } else {
                _this.$Message.error("请输入必填项");
                _this.loading = false;
                _this.$nextTick(() => {
                    _this.loading = true;
                });
            }
        });

      },
      cancel(value) {
        this.$emit("on-change", this.visible)
      }
    },
  }
</script>

<style scoped="scoped">

</style>
